import { GetServerSidePropsContext } from 'next'
import { getCookie, setCookie } from 'cookies-next'

/** 存储格式
 *  {
 *     '/ai/mine': {
 *         path: '/ai/mine?model=STABLE_DIFFUSION',
 *         scrollTop: 100,
 *         pageSize: 200
 *     }
 * }
 */

interface CacheDataProps {
  [key: string]: CacheValueProps
}

export interface CacheValueProps {
  path: string
  scrollTop: number
  pageSize: number
}

const CACHE_KEY = 'scroll-cache'

/** 在客户端使用 */
export const setScrollCache = ({
  key: _key,
  value,
}: {
  key: string
  value: CacheValueProps
}) => {
  const key = _key.split('?')[0]
  const data = JSON.parse((getCookie(CACHE_KEY) as string) || '{}')
  data[key] = {
    ...value,
    pageSize: Math.min(value.pageSize, 500), // 限制500条，不然后端会炸
  }

  setCookie(CACHE_KEY, JSON.stringify(data), {
    maxAge: 60 * 60, // 保留1小时
  })
}

export const delScrollCache = ({ key: _key }: { key: string }) => {
  const key = _key.split('?')[0]

  const scrollCaches = getScrollCaches()

  if (scrollCaches[key]) {
    delete scrollCaches[key]
    setCookie(CACHE_KEY, JSON.stringify(scrollCaches), {
      maxAge: 60 * 60, // 保留1小时
    })
  }
}

/** 在服务端使用 */
export const getScrollCache = (context: GetServerSidePropsContext) => {
  const scrollCache = JSON.parse(
    (getCookie(CACHE_KEY, {
      req: context.req,
      res: context.res,
    }) as string) || '{}'
  )

  /** 获取当前页路由 */
  const pathname = context.resolvedUrl.split('?')[0]

  return scrollCache[pathname]?.path === decodeURIComponent(context.resolvedUrl)
    ? scrollCache[pathname]
    : {}
}

/** 在客户端使用 */
export const getScrollCaches = () => {
  return JSON.parse((getCookie(CACHE_KEY) as string) || '{}') as CacheDataProps
}
